module.exports = __webpack_public_path__ + "static/img/question-bg.78a2677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/question-bg.png
// module id = qflV
// module chunks = 0